import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PublicRequestCard } from "@/components/PublicRequestCard";
import { startUnlock } from "@/lib/checkout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HomeRequests = () => {
  const [requests, setRequests] = useState([]);
  const [unlocking, setUnlocking] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("cm_unlock_all") || "";
    axios
      .get(`${API}/public/requests`, { headers: token ? { "X-Unlock-Token": token } : {} })
      .then(({ data }) => setRequests((data.requests || []).slice(0, 6)))
      .catch(() => {});
  }, []);

  const unlock = async (r) => {
    setUnlocking(r.id);
    try {
      await startUnlock(r.id);
    } catch {
      setUnlocking(null);
    }
  };

  if (requests.length === 0) return null;

  return (
    <section id="richieste-attive" className="relative py-20 sm:py-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-wrap items-end justify-between gap-6 mb-12"
        >
          <div className="max-w-xl">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-600 mb-4">
              La bacheca al contrario
            </p>
            <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#0A192F]">
              Chi sta cercando casa adesso
            </h2>
            <p className="mt-4 text-slate-600 text-[15px] leading-relaxed">
              Hai una casa che corrisponde? Sblocchi il contatto e la proponi tu.
              I contatti sono riservati e si sbloccano solo a pagamento.
            </p>
          </div>
          <a
            href="/richieste"
            data-testid="home-requests-all-link"
            className="group inline-flex items-center gap-2 rounded-full border-2 border-[#0A192F] text-[#0A192F] font-bold px-6 py-3 text-sm hover:bg-[#0A192F] hover:text-white transition-colors duration-300"
          >
            Vedi tutte le richieste
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
          </a>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {requests.map((r) => (
            <PublicRequestCard key={r.id} r={r} onUnlock={unlock} unlocking={unlocking} />
          ))}
        </div>
      </div>
    </section>
  );
};
